import React, {useEffect, useState} from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useHistory } from 'react-router'

import { userFormData, userFormEditData } from './userFormData'
import { userTable } from './userTable'

// Component
import CardTable from "components/Cards/CardTable"
import FormCustom from "components/Forms/FormCustom"
import ConfirmModal from 'components/Modal/ConfirmModal'

// API
import { changeStatusUser, getAllDataTableUsers, insertNewUser, updateUser } from './api/userAPI'
import { getDropdownRoles } from './api/roleAPI'


export default function User() {
    const history = useHistory();
    
    const [addForm, setAddForm] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [editFormValue, setEditFormValue] = useState(null);

    const [dataTable, setDataTable] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);

    const [active, setActive] = useState(false);

    const [formData, setFormData] = useState(null);
    
    const [formDataArr, setFormDataArr] = useState([]);
    const [formEditDataArr, setFormEditDataArr] = useState([]);

    // Select-Option Data
    const [dropdownRole, setDropdownRole] = useState([]);

    // Type Search
    const [typeSearch, setTypeSearch] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [errors, setErrors] = useState(null);
    const [deletePopUp, setDeletePopUp] = useState([{show:false, id:null}])

    // Component is Active?
    useEffect(() => {
        setActive(true);
        return () => {
            setActive(false)
        }
    }, [])

    // Loading
    useEffect(() => {
        if(isLoading === true) {
            toast.loading("Data Diproses...");
        }
    }, [isLoading])

    // handle when state active changed
    useEffect(() => {
        setIsLoading(true);

        getAllDataTableUsers().then((response) => {
            active === true && setDataTable(response.data.data)
        })
        .catch(error => console.error(`Error: ${error}`))
        .finally(setIsLoading(false))

        return () => {
            setDataTable([]);
        }
        
    }, [active])

    // Clear Form Data When First Time Load Component
    useEffect(() => {
        setFormData(null);
    }, [])

    // Select-Option Data
    // Load Data Roles
    useEffect(() => {
        setIsLoading(true);

        getDropdownRoles()
        .then((response) => {
            setDropdownRole(response.data.data);
        })
        .catch(err => setErrors(err))
        .finally(setIsLoading(false))

        return () => {
            setDropdownRole([]);
        }
    }, [active])
    // End Select-Option Data

    // Load Form Data Arr
    useEffect(() => {
        setFormDataArr(userFormData(dropdownRole));

        return () => {
            setFormDataArr([])
        }
    }, [dropdownRole])

    // Load Form Edit Data Arr
    useEffect(() => {
        setFormEditDataArr(userFormEditData(dropdownRole));
    }, [dropdownRole])

    // Clear Form Data When First Time Load Component
    useEffect(() => {
        setFormData(null);
    }, [active]);

    // Handle when user click add button
    function handleInsert() {
        setActive(false);
        setAddForm(true);
    }

    // Handle when User Click Cancel
    const handleCancelButton = () => {
        setAddForm(false);
        setEditForm(false);
        setEditFormValue(null);
        setFormData(null);
        setActive(true);
    }

    // Handle when User Click Edit Button
    const handleEdit = (rowData) => {
        setActive(false)
        console.log(rowData);
        setEditFormValue(rowData);
        setEditForm(true);
    }

    // Handle when User Click Delete Button
    const handleDelete = (rowData) => {
        setDeletePopUp({
            show: true,
            id: rowData.id_user
        })
    }

    // Handle when User Confirm to Delete Data
    const handleConfirmTrue = () => {
        setActive(false)
        if(deletePopUp.show && deletePopUp.id) {
            setIsLoading(true);

            changeStatusUser(deletePopUp.id)
            .then((response) => setResult(response))
            .catch((err) => setErrors(err))
            .finally(endSubmitProcess())
        }
    }

    // Handle when User Deny to Confirm Delete Data
    const handleConfirmFalse = () => {
        setDeletePopUp({
            show: false,
            id: null
        })
    }

    // Handle when User Submit New Data
    const handleInsertSubmit = (e) => {
        e.preventDefault();

        setIsLoading(true);

        const data = new FormData();

        if(formData !== null) {
            Object.keys(formData).forEach(key => data.append(key, formData[key]));
        }

        insertNewUser(data)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }

    // Handle when USer Submit Update Data
    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        if(formData !== null) {
            const id = editFormValue.id_user;

            setIsLoading(true);

            const data = new FormData();

            Object.keys(formData).forEach(key => data.append(key, formData[key]));

            // console.log(data.getAll('nama_user'));

            updateUser(data, id)
            .then((response) => setResult(response))
            .catch((err) => setErrors(err))
            .finally(endSubmitProcess());

        } else {
            toast.error("Tidak ada data yg di ubah");
        }
    }

    //Check if request is failed
    useEffect(() => {
        if(errors !== null) {
            toast.error(errors.message);
            }
    }, [errors])

    // Check if request is success
    useEffect(() => {
        if(result !== null) {
            if(result.data.success === true) {
                toast.success(result.data.message);
                setFormData(null);
                setAddForm(false);
                setEditForm(false);
                setActive(true);
                history.push(`/config/User`);
            } else {
                let numericArray = [];
                for (let err in result.data.errors) {
                    numericArray.push(result.data.errors[err])
                }

                if(numericArray !== []) {
                    toast.error(numericArray[0]);
                }
            }
            setResult(null);
        }
    }, [history, result])

    // Set Inputted Data to Form
    const setData = (key, value) => {
        console.log(formData);
        return setFormData({...formData, [key]: value});
    }

    // Handle when submit process is end
    const endSubmitProcess = () => {
        setDeletePopUp({show: false})
        setIsLoading(false);
    }

    // Handle Search
    const handleSearch = (e) => {
        setTypeSearch(e.target.value);
    }

    // Handle when Searching Changes
    useEffect(() => {
        const getDataSearchResult = () => {
            getAllDataTableUsers(typeSearch)
            .then((response) => {
                setDataTable(response.data.data)
            })
            .catch(error => console.error(`Error: ${error}`))
            .finally(setIsLoading(false))
            setPageNumber(0);
        }

        const getData = () => {
            getAllDataTableUsers()
            .then((response) => {
                setDataTable(response.data.data);
            })
            .catch(error => console.error(`Error: ${error}`))
            .finally(setIsLoading(false));
            setPageNumber(0);
        }

        let timer = setTimeout(() => {
            if(typeSearch) {
                    getDataSearchResult();
                } else {
                    getData();
                }
        }, 1000);

        return () => clearTimeout(timer)
    }, [typeSearch]);

    // Handle when Page number Changes
    const changePage = ({selected}) => {
        setPageNumber(selected);
    }

    if(addForm === true) return (
        <div>
            <div className='flex flex-wrap mt-4'>
                <div className='w-full mb-12 px-4'>
                    <Toaster />
                    <FormCustom
                        title = {"Tambah Data"}
                        formDataArr = {formDataArr}
                        handleSubmit = {handleInsertSubmit}
                        handleCancelButton = {handleCancelButton}
                        setData = {setData}
                        editFormValue ={null}
                    />    
                </div>
            </div>
        </div>
    );

    if(editForm === true) return (
        <div>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <Toaster />
                    <FormCustom
                        title = {"Edit Data"}
                        formDataArr = {formEditDataArr}
                        handleSubmit = {handleUpdateSubmit}
                        handleCancelButton = {handleCancelButton}
                        setData = {setData}
                        editFormValue = {editFormValue}
                    />
                </div>
            </div>
        </div>
    )

    return (
        <div>
            <div className='flex flex-wrap mt-4'>
                <div className='w-full mb-12 px-4'>
                    {deletePopUp.show && <div><ConfirmModal handleIfTrue={(e) => handleConfirmTrue()} handleIfFalse={(e) => handleConfirmFalse()} message="Anda yakin ingin mengubah status user?" /></div>}
                    <Toaster />
                    <CardTable
                        tableTitle = "Tabel User"
                        cols = {userTable(handleEdit, handleDelete)}
                        handleInsert = {(e) => handleInsert()}
                        data = {dataTable}
                        handleSearch = {handleSearch}
                        pageNumber = {pageNumber}
                        changePage = {changePage}
                    />
                </div>
            </div>
        </div>
    )
}